export namespace IInsiderModalRequest {
  export enum InsiderModalContext {
    INSIDER_MODAL_CONTEXT_UNKNOWN = 'INSIDER_MODAL_CONTEXT_UNKNOWN',
    MARKETING_PAGE = 'MARKETING_PAGE',
    MOBILE_HOME_FEED = 'MOBILE_HOME_FEED',
    BRAND_PAGE = 'BRAND_PAGE',
    PDP = 'PDP',
    CHECKOUT_SHOPPING_BAG = 'CHECKOUT_SHOPPING_BAG',
    CHECKOUT_SHIPPING_METHOD = 'CHECKOUT_SHIPPING_METHOD',
    REMIND_ME_LATER = 'REMIND_ME_LATER',
    SETTINGS_PAGE = 'SETTINGS_PAGE',
    CHECKOUT = 'CHECKOUT',
  }

  /**
   * Return an instance of IInsiderModalRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IInsiderModalRequest>
  ): IInsiderModalRequest =>
    ({
      ...(partial ?? {}),
    }) as IInsiderModalRequest;
}

/**
 * Used by clients to request a specific insider modal flow
 */
export interface IInsiderModalRequest {
  insider_modal_context:
    | keyof typeof IInsiderModalRequest.InsiderModalContext
    | undefined;
}
